import React from 'react';
import './SummaryStatusChip.css';

/**
 * Passive status chip for interim summary generation.
 *
 * Shown near the chat input while a summary is being created (manual
 * button or automatic threshold), then briefly on success/failure.
 * Never blocks the input — the writer can keep chatting.
 *
 * @param {string|null} status - 'creating' | 'success' | 'error' | null (hidden)
 * @param {string} message - Text to display
 * @param {function} onDismiss - Called when the writer dismisses the chip
 */
export function SummaryStatusChip({ status, message, onDismiss }) {
  if (!status) return null;

  return (
    <div
      className={`summary-status-chip summary-status-chip--${status}`}
      role="status"
      aria-live="polite"
    >
      {status === 'creating' && (
        <span className="summary-status-chip__spinner" aria-hidden="true" />
      )}
      <span className="summary-status-chip__text">{message}</span>
      <button
        type="button"
        className="summary-status-chip__dismiss"
        onClick={onDismiss}
        aria-label="Dismiss"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}

export default SummaryStatusChip;
